import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'profile--edit-top-3-specialisms-and-keywords-modal',
    ];

    openModal(event) {
        event.preventDefault();

        this.profileEditTop3SpecialismsAndKeywordsModalOutlet.openModal();
    }
}
